import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { clientMessage } from '../../utils/common';
import { PAYMODE } from '../../../../common/src/constant';
import { RupeeSymbol } from '../rupeeSymbol';

class EmiPlansList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlan: null
    };
  }

  componentDidMount() {
    const { emiPlans, payableAmount } = this.props.planDetails;

    this.setState({
      emiPlans,
      txnAmount: payableAmount,
      selectedPlan:
        emiPlans && emiPlans.details && emiPlans.details.length ? emiPlans.details[0] : null
    });
  }

  setActivePlan(plan) {
    this.setState({ selectedPlan: plan });
    this.props.setEmiPlan(plan);
  }

  render({ cache, instanceKey, miniCart }, { emiPlans, selectedPlan, txnAmount }) {
    const locale = clientMessage(PAYMODE.EMI.toLowerCase(), cache);

    return (
      <div className={`ptm-emi-plan-wrap`}>
        <div
          className={`ptm-close-wrap ptm-pos-a ptm-closeIcon`}
          onClick={() => {
            this.props.hideEmiPlans();
          }}
        >
          <span className={`ptm-cross ptm-pos-r`} />
        </div>
        <div className={`ptm-emi-heading  ptm-w100-ib`}>
          <span className={`ptm-left ptm-body-color`}>Select EMI Plan</span>
          <span className={`ptm-right`}>
            <RupeeSymbol /> {txnAmount}
          </span>
        </div>
        <div className="ptm-emi-innerbox">
          <div className={`ptm-emi-head-strip ptm-body-bg ptm-body-color`}>
            <span className={`ptm-body-color`}>Duration</span>
            <span className={`ptm-body-color`}>EMI per month</span>
            <span className={`ptm-body-color`}>Total Cost</span>
          </div>
          <div className={`ptm-emi-plancard-wrap`}>
            {emiPlans &&
              emiPlans.details.length &&
              emiPlans.details.map(plan => {
                return (
                  <div
                    className={`ptm-emi-plancard ptm-pos-r ptm-global-border`}
                    onClick={() => {
                      this.setActivePlan(plan);
                    }}
                  >
                    <label className="ptm-lbl">
                      <input
                        type="radio"
                        className={`ptm-margin0`}
                        name={`plan${instanceKey}`}
                        checked={plan.planId === selectedPlan.planId}
                      />
                      <span className="ptm-checkmark" />
                      <div className={`ptm-emi-plan-dscr`}>
                        <span className={`ptm-body-color`}>{plan.interval} Months</span>
                        <span className={`ptm-body-color`}>
                          <RupeeSymbol /> {plan.emi} ({plan.rate}% p.a.)
                        </span>
                        <span className={`ptm-body-color`}>
                          <RupeeSymbol /> {plan.effectivePrice}
                        </span>
                      </div>
                      {plan.gratifications && plan.gratifications.length ? (
                        <p
                          className={`ptm-cashback-txt`}
                          onClick={() => {
                            this.props.showMiniCart(plan);
                          }}
                        >
                          <RupeeSymbol /> {plan.gratifications[0].value}{' '}
                          {plan.gratifications[0].label}
                          {/* to show droopdown arrow only when mini cart is available */}
                          {miniCart && <span className={`ptm-dropdown-green`} />}
                        </p>
                      ) : (
                        ''
                      )}
                    </label>
                  </div>
                );
              })}

            <div className={`ptm-emi-note ptm-body-bg ptm-body-color`}>
              <h5 className={`ptm-body-color`}>Things to note:</h5>
              <ul className={`ptm-note-list ptm-body-color ptm-note-listing `}>
                <li className={`ptm-body-color`}>{locale.label.emiConvert}</li>
                <li className={`ptm-body-color`}>{locale.label.cashback}</li>
                <li className={`ptm-body-color`}>{locale.label.kycText}</li>
              </ul>
            </div>
            {/* <div className={`ptm-btn-wrapper ptm-body-bg`}>
              <button
                className={`ptm-custom-btn`}
                onClick={() => {
                  this.props.selectEmiPlan(selectedPlan);
                }}
              >
                Proceed
              </button>
            </div> */}
          </div>
        </div>
        <div className={`ptm-btn-wrapper ptm-body-bg`}>
          <button
            className={`ptm-custom-btn`}
            onClick={() => {
              this.props.selectEmiPlan(selectedPlan);
            }}
          >
            Proceed
          </button>
        </div>
      </div>
    );
  }
}

export default connect('cache, instanceKey')(EmiPlansList);



// WEBPACK FOOTER //
// ./components/emiPlans/index.js